/**
 * Constants to be used for validation of values in Grid cells
 */ export var TaskValidationConstants;
(function(TaskValidationConstants) {
    /** Maximum task title length. Matches TaskLogic.cs : TitleSizeLimit */ TaskValidationConstants.TitleMaxLength = 255;
    /** Minimum date supported by Project client. We do not have any dependency on project, we can change this if needed. */ TaskValidationConstants.MinDateValue = "1984-01-01";
    /** Maximum date supported by Project client. We do not have any dependency on project, we can change this if needed. */ TaskValidationConstants.MaxDateValue = "2149-12-31";
})(TaskValidationConstants || (TaskValidationConstants = {}));
